import { memo, version } from "react";

import {
    ExperiencePerformanceTypes,
    payloadPublisher,
    TenantType
} from "@atlassian/ufo";
import AnalyticsWebClient from "@atlassiansox/analytics-web-client";

import { resourceTimingsConfig } from "../react-ufo/utils/get-resource-config";
import { useAnalyticsClient } from "../wac-analytics/analytics-client";

export const InitUFOV1 = memo(() => {
    const analyticsClient: AnalyticsWebClient | null = useAnalyticsClient();
    if (analyticsClient) {
        payloadPublisher.setup({
            featureFlagClient: { getValue: () => true },
            product: "marketing",
            gasv3: analyticsClient,
            app: {
                version: { web: "1.0.0" },
                framework: { name: "react", version }
            },
            tenantType: TenantType.RealUser,
            resourceTimings: resourceTimingsConfig,
            performanceConfig: {
                histogram: {
                    [ExperiencePerformanceTypes.PageLoad]: {
                        initial: {
                            fmp: "1000_2000_3000_4000",
                            tti: "1000_2000_3000_4000"
                        },
                        transition: {
                            fmp: "1000_2000",
                            tti: "1000_2000"
                        }
                    },
                    [ExperiencePerformanceTypes.PageSegmentLoad]: {
                        initial: {
                            fmp: "1000_2000",
                            tti: "1000_2000"
                        },
                        transition: {
                            fmp: "1000_2000",
                            tti: "1000_2000"
                        }
                    },
                    [ExperiencePerformanceTypes.InlineResult]: {
                        result: "1000_2000",
                        response: "1000_2000"
                    },
                    [ExperiencePerformanceTypes.Custom]: {
                        duration: "1000_2000"
                    }
                }
            }
        });
    }
    return null;
});
